import { useEffect } from 'react';
import type { StorageAllocationsOverviewResponse } from 'src/apis/storage/types';
import type { StorageOfferDetailsRequest } from 'src/apis/storage/use-storage-offer-details';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageOfferDetails?: StorageOfferDetailsRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useOptionalStorageAllocations({
  storageOfferDetails,
}: HookOptions) {
  const allocations = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) => {
      return axios.request<StorageAllocationsOverviewResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageOfferDetails?.response) return;
    if (!storageOfferDetails.response.data._links.getAllocations) return;

    allocations.execute({
      url: storageOfferDetails.response.data._links.getAllocations.href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageOfferDetails?.response]);

  if (
    storageOfferDetails?.response &&
    !storageOfferDetails.response.data._links.getAllocations
  )
    return;

  return allocations;
}

export type StorageAllocationsRequest = ReturnType<
  typeof useOptionalStorageAllocations
>;
